import {ZyusetuFieldKeyFragmentFragment, ZyusetuFieldKeyType,} from "@/graphql/graphql";
import {Controller, useFormContext} from "react-hook-form";
import {FormSchema} from "@/components/pages/Zyusetu/ZyusetuEditorSection.tsx";
import {Autocomplete, TextField} from "@mui/material";
import {zyusetuValueIntoZodValue} from "@/hooks/useGetFirstContent";

interface ZyusetuStringAutocompleteFieldProps {
  fieldKey: ZyusetuFieldKeyFragmentFragment;
  onFocus: () => void;
  updateField: (
    keyId: string,
    keyName: string,
    value: FormSchema<ZyusetuFieldKeyType.StringAutoComplete>[string],
  ) => Promise<void>;
  isAvailable: boolean;
}

export function ZyusetuStringAutocompleteField({
                                                 fieldKey,
                                                 onFocus,
                                                 updateField,
                                                 isAvailable,
                                               }: ZyusetuStringAutocompleteFieldProps) {
  const {control} =
    useFormContext<FormSchema<ZyusetuFieldKeyType.StringAutoComplete>>();
  return (
    <Controller
      name={fieldKey.keyName}
      control={control}
      render={({field, formState: {errors}, fieldState: {isDirty}}) => {
        return (
          <Autocomplete
            ref={field.ref}
            value={field.value.value ?? ""}
            onInputChange={(_, newValue, reason) => {
              if (reason !== "selectOption" && reason !== "reset")
                field.onChange(
                  zyusetuValueIntoZodValue(fieldKey, newValue ?? ""),
                );
            }}
            disabled={!isAvailable}
            onFocus={onFocus}
            onChange={(_, newValue) => {
              field.onChange(
                zyusetuValueIntoZodValue(fieldKey, newValue ?? ""),
              );
            }}
            onBlur={async () => {
              if (errors?.[fieldKey.keyName]?.value?.message) return;
              if (!isDirty) return;
              
              await updateField(fieldKey.id, fieldKey.keyName, field.value);
            }}
            freeSolo={true}
            options={fieldKey.items ?? []}
            renderInput={(params) => {
              // console.log(params);
              return (
                <TextField
                  multiline
                  minRows={fieldKey.keyStyle.lines ?? undefined}
                  inputRef={field.ref}
                  {...params}
                  disabled={!isAvailable}
                  error={!!errors?.[fieldKey.keyName]?.value?.message}
                  helperText={
                    errors?.[fieldKey.keyName]?.value?.message as string
                  }
                  fullWidth
                  size={"small"}
                />
              );
            }}
          />
        );
      }}
    />
  );
}
